import * as React from 'react';
import  { useState } from "react";
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { Instance } from '@popperjs/core';
import Construction from 'images/construction.png'; 
import Construction2 from 'images/construction2.png';


const ExpertiseTooltip= () => {
  const [source, setSource] = useState(Construction);
  const positionRef = React.useRef<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const popperRef = React.useRef<Instance>(null);
  const areaRef = React.useRef<HTMLDivElement>(null);
  function over()
  {
    setSource(Construction2);
  }
  function out()
  {
    setSource(Construction);
  }
  const handleMouseMove = (event: React.MouseEvent) => {
    //positionRef.current = { x: event.clientX, y: event.clientY };

    if (popperRef.current != null) {
      popperRef.current.update();
    }
  }; 

  return (
    <>
    <Tooltip style={{ fontSize: 18}}
      title={ <div >
              <h1 style={{display: 'flex', justifyContent: 'center'}}>Expertise</h1>
              <div className="flex flex-row">
                
                <div className="flex-col" style={{width:'400px', display : 'inline-block'}}>
                    <ul>
                        <li>Entreprises, commerces</li>
                        <li>Industries, usines</li>
                        <li>Suvis de Chantiers de construction </li>
                        <li>Villes et municipalités</li>
                        <li>Tourisme et villégiature</li>
                        <li>Terrains de golf</li>
                        <li>Concessionnaires automobiles</li>
                        <li>Centres commerciaux</li>
                        <li>installations sportives</li>
                        <li>Courtiers immobilier</li>
                        <li>Particuliers, Résidences de prestige</li> 
                    </ul>
                </div>
                <div className="flex-col" style={{width:'400px',display : 'inline-block'}}>
                    <ul>    
                        <li>Spectacles, Festivals et Événements</li>
                        <li>Marches et démonstrations</li>
                        <li>Mariages , célébrations et Photographies de groupe</li>
                        <li>Emplacements récréatifs</li>
                        <li>Événements sportifs</li>
                        <li>Réclamations d'assurances</li>
                        <li>Inspection d'infrastructures</li>
                        <li>Chantiers de construction</li>
                        <li>Suivi de travaux en hauteur</li>
                        <li>Marketing publicitaire Télévision, web et cinéma</li>
                        <li>Visualisation architecturale et visites virtuelles 360</li>
                    </ul>
                </div>
              </div>
              </div> 
              }
      placement="bottom"
      arrow
      PopperProps={{
        popperRef,
        anchorEl: {
          getBoundingClientRect: () => {
            return new DOMRect(
              positionRef.current.x,
              areaRef.current!.getBoundingClientRect().y,
              357,
              75,
            );
          },
        },
      }}
    >
      <Box  style={{left:100, top: -100}} 
        ref={areaRef}
        sx={{ color: 'primary.contrastText', p: 4 }}
      >
       <img width="50" height="50" border-radius="50%" onMouseOver={over} onMouseOut={out} src={source} alt="Expertise" />
       
      </Box>
    </Tooltip>
    </>
  );
}

export default ExpertiseTooltip;